import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { CloudUploadIcon as SaveIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type SaveFormProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

export const SaveFormButton: React.FC<SaveFormProps> = observer(
  ({ onClick, disabled, label }) => {
    const rootStore = useRootStore();
    const { prefStore } = rootStore;

    return (
      <Button
        variant={"action"}
        size={prefStore.toolbarSize}
        startIcon={<SaveIcon />}
        disabled={disabled === undefined ? false : disabled}
        onClick={onClick}
      >
        {!label ? "Guardar" : label}
      </Button>
    );
  }
);
